/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ImportStationData$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * Indicates the type of data import:
 *   * INJECTION : injection of new data
 *   * CORRECTION : correction of existing data
 *   * PREDICTION : injection of predictive data (override existing data on the timeframe)
 */
  dataImportType: 'INJECTION' | 'CORRECTION' | 'PREDICTION';
      body: Blob
}

export function importStationData(http: HttpClient, rootUrl: string, params: ImportStationData$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, importStationData.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('dataImportType', params.dataImportType, {});
    rb.body(params.body, 'text/csv');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

importStationData.PATH = '/stations/{uid}/data/import';
